import { ButtonProtected } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { Scope } from '../../../../../../../../enums/scope'
import { Side } from '../../../../../../../../enums/side'
import { TrackingContext } from '../../../../../../../../enums/trackingContext'
import { useBankTransactionDrawer } from '../../../../contexts'
import { SandboxBlockedTooltip } from '../../../SandboxBlockedTooltip'
import { BookkeepingItemsList } from '../ListElements/BookkeepingItemsList'
import { TransactionsList } from '../ListElements/TransactionsList/TransactionsList'
import { MarkedAsPrivateToggle } from '../MarkedAsPrivateToggle'
import { NewInvoice } from '../NewInvoice/NewInvoice'
import { NewReceipt } from '../NewReceipt/NewReceipt'
import * as Styled from './styles'

interface DefaultStateProps {
  transactionsSide?: string
  handleViewAllItemsClick?: () => void
  handleCreateManualPaymentClick?: () => void
  handleViewTransactionsClick?: () => void
}

export const DefaultState = ({
  transactionsSide,
  handleViewAllItemsClick,
  handleCreateManualPaymentClick,
  handleViewTransactionsClick,
}: DefaultStateProps): ReactElement => {
  const { t } = useTranslation()
  const { accountCurrencyIsSameAsOrganizationCurrency, combinedTransactions, isPrivate } = useBankTransactionDrawer()

  return (
    <>
      {!isPrivate && (
        <>
          {transactionsSide === Side.Credit && <NewReceipt />}
          {transactionsSide === Side.Debit && <NewInvoice />}
          <Styled.LargeDivider />
          <BookkeepingItemsList onViewAll={handleViewAllItemsClick} />
          <Styled.LargeDivider />
          {accountCurrencyIsSameAsOrganizationCurrency && (
            <SandboxBlockedTooltip>
              <ButtonProtected
                fullWidth
                onClick={handleCreateManualPaymentClick}
                scopes={Scope.BankReconciliationWrite}
                trackingContext={TrackingContext.BankTransactions}
                variant="outlined"
              >
                {t('create_manual_payment_modal.cta')}
              </ButtonProtected>
            </SandboxBlockedTooltip>
          )}
          {combinedTransactions.size > 0 ? (
            <>
              <Styled.LargeDivider />
              <TransactionsList onViewAll={handleViewTransactionsClick} />
            </>
          ) : (
            <ButtonProtected
              onClick={handleViewTransactionsClick}
              scopes={Scope.BankReconciliationWrite}
              trackingContext={TrackingContext.BankTransactions}
              variant="outlined"
            >
              {t('bank_transactions.drawer.transactions.cta')}
            </ButtonProtected>
          )}
          <Styled.LargeDivider />
        </>
      )}
      <MarkedAsPrivateToggle />
    </>
  )
}
